import { render } from "./index.vue?vue&type=template&id=649fdc20&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=649fdc20&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-649fdc20"],['__file',"src/vab/components/VabSideBar/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "649fdc20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('649fdc20', __exports__)) {
    console.log('reload')
    api.reload('649fdc20', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=649fdc20&scoped=true", () => {
    console.log('re-render')
    api.rerender('649fdc20', render)
  })

}


export default __exports__